import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames/bind';
import { Link, withRouter } from 'react-router-dom';

import LogoutButton from '../LogoutButton';

import {isSessionUserPlatformAdmin} from '../../../selectors/users';
import {refreshLinks, toggleLinkExpansion} from '../../../actions/navbar';

import styles from './styles.scss';

const getLinkClasses = (link) => {

    const cx = classnames.bind(styles);

    return cx({
        'link': true,
        'link--active': link.active,
        'link--has-children': link.children.length > 0
    });
};

const getChildLinkClasses = (link) => {

    const cx = classnames.bind(styles);

    return cx({
        'child-link': true,
        'child-link--active': link.active
    });
};

const getChildLinkListClasses = (link) => {

    const cx = classnames.bind(styles);

    return cx({
        'child-link-list': true,
        'child-link-list--expanded': link.expanded
    });
};

const LoggedInSidebar = props => {

    return (
        <ul>
            {props.links.map((link) => {
                let ariaLabel = link.name + (link.children.length > 0 ? (link.expanded ? ', button expanded, sub menu' : ', button collapsed, sub menu') : '');
                return (
                    <li key={link.id}>

                        { link.link && <Link className={getLinkClasses(link)} to={link.link}>{ link.name }</Link> }
                        {!link.link && (
                            <a
                                href=""
                                onClick={props.onLinkToggle.bind(this, link.id)}
                                className={getLinkClasses(link)}
                                aria-label={ariaLabel}
                            >
                                { link.name }
                            </a>
                        )}

                        {link.expanded && link.children.length > 0 &&

                            <ul className={getChildLinkListClasses(link)}>
                                {link.children.map((childLink) => {
                                    return (
                                        <li key={childLink.id}>
                                            <Link className={getChildLinkClasses(childLink)} to={childLink.link}>{ childLink.name }</Link>
                                        </li>
                                    )
                                })}
                            </ul>
                        }
                    </li>
                )
            })}

            <li>
                <LogoutButton className={styles['logout-link']}>
                    Logout
                </LogoutButton>
            </li>
        </ul>
    );
};

const LoggedOutSidebar = props => {

    return (
        <ul>
            {props.links.map((link, i) => {
                if (link.link) {
                    return (
                        <li key={i}>
                            <Link className={getLinkClasses(link)} to={link.link}>{ link.name }</Link>
                        </li>
                    )
                }
            })}
        </ul>
    );
};

class PageSidebar extends React.Component {

    componentDidMount() {

        this.props.refreshLinks(window.location.pathname, this.props.isLoggedIn, this.props.isPlatformAdmin);
    }

    componentWillReceiveProps(nextProps, nextContext) {

        const currentProps = this.props;

        if (
            currentProps.isLoggedIn !== nextProps.isLoggedIn ||
            currentProps.isPlatformAdmin !== nextProps.isPlatformAdmin
        ) {
            this.props.refreshLinks(window.location.pathname, nextProps.isLoggedIn, nextProps.isPlatformAdmin);
        }
    }

    _toggleLinkExpansion(linkId, event) {

        event.preventDefault();
        this.props.toggleLinkExpansion(this.props.links, linkId);
    }

    render() {

        return (
            <nav className={ styles.sidebar } role='navigation'>

                {this.props.isLoggedIn &&
                    <LoggedInSidebar
                        links={this.props.links}
                        onLinkToggle={this._toggleLinkExpansion.bind(this)}
                        onLogoutClick={this._logout}
                    />
                }

                {!this.props.isLoggedIn &&
                    <LoggedOutSidebar links={this.props.links} />
                }

            </nav>
        )
    }
}

function mapStateToProps(state) {
    return {
        isLoggedIn: !!state.session.user,
        isPlatformAdmin: isSessionUserPlatformAdmin(state),
        links: state.navbar.links
    }
}

function mapDispatchToProps(dispatch) {
    return {
        refreshLinks(pathname, isLoggedIn, isPlatformAdmin) {
            dispatch(refreshLinks(pathname, isLoggedIn, isPlatformAdmin));
        },
        toggleLinkExpansion(links, linkId) {
            dispatch(toggleLinkExpansion(links, linkId));
        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PageSidebar));